import type { ReactElement } from "react";
import type { MarkdownTextParams } from "@playbookai/widget-schemas";
import { TruncatedText } from "../../molecules/TruncatedText/index.js";
import type { WidgetBodyProps } from "../types.js";
import { MarkdownContent } from "./MarkdownContent.js";

export function MarkdownTextWidget({
  data,
}: WidgetBodyProps<MarkdownTextParams>): ReactElement {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden">
      <h3 className="text-sm font-semibold text-pb-text">
        <TruncatedText>{data.title || "Untitled"}</TruncatedText>
      </h3>
      {data.markdown.trim() ? (
        <div className="min-h-0 flex-1 overflow-hidden [mask-image:linear-gradient(to_bottom,black_75%,transparent)]">
          <MarkdownContent
            markdown={data.markdown}
            className="line-clamp-[10]"
          />
        </div>
      ) : (
        <div className="flex flex-1 items-center justify-center rounded-md border border-dashed border-pb-border px-4 text-center text-sm text-pb-text-muted">
          Add Markdown in the expanded editor
        </div>
      )}
    </div>
  );
}
